<template>
    <div>
        <div v-if="confirmStatus == 'process'">
            <a-card :bordered="false">
                <div style="font-weight:500;font-size:18px">
                    {{$t('global.basicInfo')}}
                </div>
                <a-divider />
                <a-row :gutter="24" style="margin-left: -16px; margin-right: -16px;">
                    <a-col style="padding-left:16px;padding-right:16px" :xs="{span:24}" :sm="{span:24}" :lg="{span:24}">
                        <div class="antd-pro-components-description-list-index-term" style="white-space: nowrap">{{$t('supervise.templateName')}}</div>
                        <div class="antd-pro-components-description-list-index-detail">{{basicParam.templateName}}</div>
                    </a-col>

                    <a-col style="padding-left:16px;padding-right:16px" :xs="{span:24}" :sm="{span:24}" :lg="{span:24}">
                        <div class="antd-pro-components-description-list-index-term" style="white-space: nowrap">{{$t('supervise.templateDescription')}}</div>
                        <div class="antd-pro-components-description-list-index-detail">{{basicParam.templateDescription}}</div>
                    </a-col>
                </a-row>
            </a-card>

            <a-card :bordered="false">
                <div style="font-weight:500;font-size:18px">
                    {{$t('supervise.option')}}
                </div>
                <a-divider />
                <a-row :gutter="24" style="margin-left: -16px; margin-right: -16px;margin-top:25px">
                    <a-col style="padding-left:16px;padding-right:16px" :xs="{span:24}" :sm="{span:24}" :lg="{span:24}">
                        <div class="antd-pro-components-description-list-index-term" style="white-space: nowrap">{{$t('supervise.locateFreq')}}</div>
                        <div class="antd-pro-components-description-list-index-detail">{{basicConfigParam.locateFreq ? basicConfigParam.locateFreq/60 + $t('global.none') : $t('global.disable')}}</div>
                    </a-col>

                    <a-col style="padding-left:16px;padding-right:16px" :xs="{span:24}" :sm="{span:24}" :lg="{span:24}">
                        <div class="antd-pro-components-description-list-index-term" style="white-space: nowrap">{{$t('supervise.autoAdjust')}}</div>
                        <div class="antd-pro-components-description-list-index-detail">{{basicConfigParam.autoAdjust ? $t('global.enable') : $t('global.disable')}}</div>
                    </a-col>

                    <a-col style="padding-left:16px;padding-right:16px" :xs="{span:24}" :sm="{span:24}" :lg="{span:24}">
                        <div class="antd-pro-components-description-list-index-term" style="white-space: nowrap">{{$t('supervise.customLocate')}}</div>
                        <div class="antd-pro-components-description-list-index-detail">{{basicConfigParam.customLocate ? $t('global.enable') : $t('global.none')}}</div>
                    </a-col>

                    <template  v-if="basicConfigParam.customLocate">
                        <a-col style="padding-left:16px;padding-right:16px" :xs="{span:24}" :sm="{span:24}" :lg="{span:24}">
                            <div class="antd-pro-components-description-list-index-term" style="white-space: nowrap">{{$t('supervise.segmentTime')}}</div>
                            <div class="antd-pro-components-description-list-index-detail">{{formatTime(basicConfigParam.customLocate[0].startTime) + '~' + formatTime(basicConfigParam.customLocate[0].endTime)}}</div>
                        </a-col>

                        <a-col style="padding-left:16px;padding-right:16px" :xs="{span:24}" :sm="{span:24}" :lg="{span:24}">
                            <div class="antd-pro-components-description-list-index-term" style="white-space: nowrap">{{$t('supervise.segmentFreq')}}</div>
                            <div class="antd-pro-components-description-list-index-detail">{{basicConfigParam.customLocate[0].intervalTime / 60 + $t('global.minute')}}</div>
                        </a-col>

                        <a-col style="padding-left:16px;padding-right:16px" :xs="{span:24}" :sm="{span:24}" :lg="{span:24}">
                            <div class="antd-pro-components-description-list-index-term" style="white-space: nowrap">{{$t('supervise.autoPowerUp')}}</div>
                            <div class="antd-pro-components-description-list-index-detail">{{basicConfigParam.autoPowerUp ? formatTime(basicConfigParam.autoPowerUp) : $t('global.none')}}</div>
                        </a-col>

                        <a-col style="padding-left:16px;padding-right:16px" :xs="{span:24}" :sm="{span:24}" :lg="{span:24}">
                            <div class="antd-pro-components-description-list-index-term" style="white-space: nowrap">{{$t('supervise.autoPowerDown')}}</div>
                            <div class="antd-pro-components-description-list-index-detail">{{basicConfigParam.autoPowerDown ? formatTime(basicConfigParam.autoPowerDown) : $t('global.none')}}</div>
                        </a-col>
                    </template>
                </a-row>
            </a-card>

            <a-card :bordered="false" >
                <div style="font-weight:500;font-size:18px">
                    {{$t('supervise.smartRule')}}
                </div>
                <a-divider />
                <a-row :gutter="24" style="margin-left: -16px; margin-right: -16px;">
                    <a-col style="padding-left:16px;padding-right:16px"  :sm="{span:24}" :lg="{span:12}">
                        <div class="antd-pro-components-description-list-index-term" style="white-space: nowrap">{{$t('supervise.timeingName')}}</div>
                        <div class="antd-pro-components-description-list-index-detail" v-if="smartConfigParam.rollCalls && smartConfigParam.rollCalls.length > 0">
                            <a-tag v-for="(item,index) in smartConfigParam.rollCalls" :key ="index" color="blue">{{formatTime(item)}}</a-tag>
                        </div>
                        <div v-else class="antd-pro-components-description-list-index-detail">{{$t('global.none')}}</div>
                    </a-col>

                    <a-col style="padding-left:16px;padding-right:16px" :sm="{span:24}" :lg="{span:12}">
                        <div class="antd-pro-components-description-list-index-term" style="white-space: nowrap">{{$t('supervise.timeingHeart')}}</div>
                        <div class="antd-pro-components-description-list-index-detail" v-if="smartConfigParam.heartClocks && smartConfigParam.heartClocks.length > 0">
                            <a-tag v-for="(item,index) in smartConfigParam.heartClocks" :key ="index" color="blue">{{formatTime(item)}}</a-tag>
                        </div>
                        <div  v-else class="antd-pro-components-description-list-index-detail">{{$t('global.none')}}</div>
                    </a-col>
                </a-row>
            </a-card>

            <a-card :bordered="false">
                <div style="font-weight:500;font-size:18px">
                    {{$t('supervise.mapFence')}}
                </div>
                <a-divider />

                <a-table :columns="fenceCloumns"  :pagination="false" :dataSource="fenceParam.data">
                    <template slot="forbidType" slot-scope="text">
                        <span v-if="text == 'in'">{{$t('global.forbidIn')}}</span>
                        <span v-if="text == 'out'">{{$t('global.forbidOut')}}</span>
                    </template>

                    <template slot="fenceType" slot-scope="text">
                        <span v-if="text == 'circle'">{{$t('supervise.circle')}}</span>
                        <span v-if="text == 'polygon'">{{$t('supervise.polygon')}}</span>
                        <span v-if="text == 'district'">{{$t('supervise.district')}}</span>
                    </template>

                    <template slot="acls" slot-scope="text">
                        <span>{{text ? text : $t('global.none')}}</span>
                    </template>

                    <template slot="applyAll" slot-scope="text">
                        <a-tag v-if="text" color="blue">{{$t('global.yes')}}</a-tag>
                        <a-tag  v-else color="gray">{{$t('global.no')}}</a-tag>
                    </template>
                </a-table>
            </a-card>

            <div style="margin-top:20px">
                <a-button style="margin-left:40px" @click="gotoPrevious">{{$t('global.pre')}}</a-button>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment'
    export default {
        name: 'ZAddTemplateConfirm',
        props:['confirmStatus','basicParam','basicConfigParam','smartConfigParam','fenceParam'],
        // data() {
        //     return {
        //         fenceCloumns:[
        //             {
        //                 title: '围栏名称',
        //                 dataIndex: 'fenceName',
        //                 key: 'fenceName'
        //             },
        //             {
        //                 title: '禁入类型',
        //                 dataIndex: 'forbidType',
        //                 key: 'forbidType',
        //                 "scopedSlots": {
        //                     "customRender": "forbidType"
        //                 },
        //             },
        //             {
        //                 title: '时间策略',
        //                 dataIndex: 'acls',
        //                 key: 'acls',
        //                 "scopedSlots": {
        //                     "customRender": "acls"
        //                 },
        //             },
        //             {
        //                 title: '围栏类型',
        //                 dataIndex: 'fenceType',
        //                 key: 'fenceType',
        //                 "scopedSlots": {
        //                     "customRender": "fenceType"
        //                 }
        //             },
        //             {
        //                 title: '应用到子机构',
        //                 dataIndex: 'applyAll',
        //                 key: 'applyAll',
        //                 "scopedSlots": {
        //                     "customRender": "applyAll"
        //                 }
        //             }
        //         ],
        //     }
        // },
        computed: {
          fenceCloumns () {
              return [{
                      title: this.$t('supervise.fenceName'),
                      dataIndex: 'fenceName',
                      key: 'fenceName'
                  },
                  {
                      title: this.$t('supervise.forbidType'),
                      dataIndex: 'forbidType',
                      key: 'forbidType',
                      "scopedSlots": {
                          "customRender": "forbidType"
                      },
                  },
                  {
                      title: this.$t('supervise.timeOption'),
                      dataIndex: 'acl',
                      key: 'acl',
                      "scopedSlots": {
                          "customRender": "acls"
                      },
                  },
                  {
                      title: this.$t('supervise.fenceType'),
                      dataIndex: 'fenceType',
                      key: 'fenceType',
                      "scopedSlots": {
                          "customRender": "fenceType"
                      }
                  },
                  {
                      title: this.$t('supervise.applyChild'),
                      dataIndex: 'applyAll',
                      key: 'applyAll',
                      "scopedSlots": {
                          "customRender": "applyAll"
                      }
                  },
                  // {
                  //     "title": this.$t('global.action'),
                  //     "dataIndex": "operation",
                  //     "key": "operation",
                  //     "scopedSlots": {
                  //         "customRender": "operation"
                  //     }
                  // }
              ]
            }
        },
        methods:{
            formatTime(timestamp){
                return moment(parseInt(moment().startOf('day').valueOf()) + timestamp * 1000).format("HH:mm")
            },
            gotoPrevious(){
                this.$emit('gotoPrevious')
            }
        }
    }
</script>